/* @flow @format */

import { type ActionType, createAction } from '../utils';
import { type CheckoutActivityInput, type FinishActivityInput } from '../../graphql/api';
import type { FailurePayload } from '../types';

type Activity = {
  +loading: boolean,
};

// Actions

export const FINISH_ACTIVITY_BEGIN: 'proc/activity/FINISH_ACTIVITY_BEGIN' = 'proc/activity/FINISH_ACTIVITY_BEGIN';
export const FINISH_ACTIVITY_SUCCESS: 'proc/activity/FINISH_ACTIVITY_SUCCESS' = 'proc/activity/FINISH_ACTIVITY_SUCCESS';
export const FINISH_ACTIVITY_FAILURE: 'proc/activity/FINISH_ACTIVITY_FAILURE' = 'proc/activity/FINISH_ACTIVITY_FAILURE';
export const CHECKOUT_ACTIVITY_BEGIN: 'proc/activity/CHECKOUT_ACTIVITY_BEGIN' = 'proc/activity/CHECKOUT_ACTIVITY_BEGIN';
export const CHECKOUT_ACTIVITY_SUCCESS: 'proc/activity/CHECKOUT_ACTIVITY_SUCCESS' =
  'proc/activity/CHECKOUT_ACTIVITY_SUCCESS';
export const CHECKOUT_ACTIVITY_FAILURE: 'proc/activity/CHECKOUT_ACTIVITY_FAILURE' =
  'proc/activity/CHECKOUT_ACTIVITY_FAILURE';

export const finishActivityBegin = createAction<typeof FINISH_ACTIVITY_BEGIN, FinishActivityInput>(
  FINISH_ACTIVITY_BEGIN
);
export const finishActivitySuccess = createAction<typeof FINISH_ACTIVITY_SUCCESS, void>(FINISH_ACTIVITY_SUCCESS);
export const finishActivityFailure = createAction<typeof FINISH_ACTIVITY_FAILURE, FailurePayload<FinishActivityInput>>(
  FINISH_ACTIVITY_FAILURE
);
export const checkoutActivityBegin = createAction<typeof CHECKOUT_ACTIVITY_BEGIN, CheckoutActivityInput>(
  CHECKOUT_ACTIVITY_BEGIN
);
export const checkoutActivitySuccess = createAction<typeof CHECKOUT_ACTIVITY_SUCCESS, void>(CHECKOUT_ACTIVITY_SUCCESS);
export const checkoutActivityFailure = createAction<
  typeof CHECKOUT_ACTIVITY_FAILURE,
  FailurePayload<CheckoutActivityInput>
>(CHECKOUT_ACTIVITY_FAILURE);

export type ActivityActionType =
  | ActionType<typeof finishActivityBegin>
  | ActionType<typeof finishActivitySuccess>
  | ActionType<typeof finishActivityFailure>
  | ActionType<typeof checkoutActivityBegin>
  | ActionType<typeof checkoutActivitySuccess>
  | ActionType<typeof checkoutActivityFailure>;

// Reducer

const initialState = { loading: false };
// TODO: save activity checkout result?
const reducer = (state: Activity = initialState, action: ActivityActionType) => {
  switch (action.type) {
    case FINISH_ACTIVITY_BEGIN:
      return { ...state, loading: true };
    case FINISH_ACTIVITY_SUCCESS:
    case FINISH_ACTIVITY_FAILURE:
      return { ...state, loading: false };
    case CHECKOUT_ACTIVITY_BEGIN:
    case CHECKOUT_ACTIVITY_SUCCESS:
    case CHECKOUT_ACTIVITY_FAILURE:
      return state;
    default:
      /*:: (action.type: empty) */
      return state;
  }
};

export default reducer;
